<template>
    <div>
        <label for="provincias">{{ $t('formularios.provincia') }}</label>
        <ValidationProvider name="provincias" id="provincias" rules="required" v-slot="{ errors }">
            <!-- `loading` deshabilita el control y activa el spinner propio del
                 multi-select: sin esto el usuario podía elegir una provincia del
                 país ANTERIOR mientras llegaba la nueva respuesta. -->
            <multiselect
                data-cy="provincia"
                :disabled="desactivar || loading"
                :loading="loading"
                v-model="selected"
                :placeholder="$t('formularios.provincia')"
                label="nombre"
                track-by="id"
                :options="provincias"
                :multiple="false"
                v-on:select="(selectedOpt) => $emit('selected', selectedOpt)"
            />
            <span v-if="loading" class="tw:block tw:text-xs tw:text-gray-500 tw:mt-1" role="status" aria-live="polite">
                {{ 'Cargando provincias…' }}
            </span>

            <span v-if="error" class="tw:block tw:text-xs tw:text-red-600 tw:mt-1" role="alert">
                {{ 'No se han podido cargar las provincias.' }}
            </span>

            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
        </ValidationProvider>
    </div>
</template>

<script>
    import { useProvincias } from '@/composables/common/useProvincias';

    export default {
        props: {
            provincia: {
                type: [Object, String, Number],
                default: null
            },
            errors: {
                type: Array,
                default: () => ([])
            },
            pais: {
                type: Number,
                default: 68 // Default to Spain
            },
            desactivar: {
                type: Boolean,
                default: false
            }
        },
        setup() {
            // La carga y su ciclo de vida (loading/error + guard de carrera) viven
            // en el composable; el .vue sólo orquesta la vista y los eventos.
            const { provincias, loading, error, cargarProvincias } = useProvincias();

            return { provincias, loading, error, cargarProvincias };
        },
        data() {
            return {
                selected: null,
                provinciaEncontrada: null 
            }
        },
        watch: {
            pais() {
                if(this.pais) this.getProvincias();
            },
            provincia: {
                handler(newProvincia) {
                    if (newProvincia && this.provincias.length > 0) {
                        this.syncSelectedProvincia(newProvincia);
                    }
                },
                immediate: true
            },
            provincias: {
                handler(newProvincias) {
                    if (this.provincia && newProvincias.length > 0) {
                        this.syncSelectedProvincia(this.provincia);
                    }
                }
            }
        },
        created() {
            this.getProvincias();
        },
        methods: {
            getProvincias() {
                // El composable descarta respuestas fuera de orden, así que un
                // cambio rápido de país ya no puede sobrescribir con datos viejos.
                this.cargarProvincias(this.pais).then(provincias => {
                    if (this.provincia) {
                        this.syncSelectedProvincia(this.provincia);
                    }

                    this.$emit('provinciasCargadas', provincias);
                });
            },
            syncSelectedProvincia(provincia) {
                if (!provincia || !this.provincias.length) return;
                
                const found = this.provincias.find(p => {
                    if (typeof provincia === 'number') {
                        return p.id === provincia;
                    }

                    if (p.id && provincia.id) {
                        return p.id === provincia.id;
                    }

                    if (p.nombre && provincia.nombre) {
                        return p.nombre.toLowerCase() === provincia.nombre.toLowerCase();
                    }

                    if (typeof provincia === 'string') {
                        return p.nombre.toLowerCase() === provincia.toLowerCase();
                    }
                    return false;
                });
                
                if (found) {
                    this.selected = found;
                    this.provinciaEncontrada = found; 

                    this.$emit('selected', found);
                } else {
                    // Clear stale selection when provincia doesn't match current country's provinces
                    this.selected = null;
                    this.provinciaEncontrada = null;
                }
            }
        }
    }
</script>
